import React, {useRef} from 'react';

import {Alert, Button, Dialog, DialogBody, DialogFooter, DialogHeader} from '@design-system';

const TITLE_ID = 'account-updated-dialog-title';
const DESCRIPTION_ID = 'account-updated-dialog-description';

/**
 * The outcome of a Professional profile save. The message is a success or an
 * error Alert, so the two outcomes differ by more than their words. It has no
 * live role of its own: the dialog is named by its title and described by the
 * message, which is what is read as it opens with focus on Dismiss.
 */
const AccountUpdatedDialog = ({isVisible, closeDialog, updateWasSuccessful, dialogMessage}) => {
  const dismissRef = useRef(null);

  const title = updateWasSuccessful ? 'Update successful' : 'Update unsuccessful';
  const subtitle = updateWasSuccessful
    ? 'Your account details were successfully updated.'
    : ["We couldn't update your account details. Please try again.", dialogMessage]
        .filter(Boolean)
        .join(' ');

  return (
    <Dialog
      open={isVisible}
      onClose={closeDialog}
      // The MUI dialog autofocused Dismiss; the same control still takes focus.
      initialFocusRef={dismissRef}
      aria-labelledby={TITLE_ID}
      aria-describedby={DESCRIPTION_ID}
      className="max-w-md"
      data-testid="account-updated-dialog">
      <DialogHeader>
        <h2 id={TITLE_ID} className="flex-1 text-lg font-semibold">
          {title}
        </h2>
      </DialogHeader>
      <DialogBody>
        <Alert
          id={DESCRIPTION_ID}
          variant={updateWasSuccessful ? 'success' : 'error'}
          live="off"
          data-testid="account-updated-message"
          className="my-0">
          {subtitle}
        </Alert>
      </DialogBody>
      <DialogFooter>
        <Button ref={dismissRef} type="button" className="min-h-11" onClick={closeDialog}>
          Dismiss
        </Button>
      </DialogFooter>
    </Dialog>
  );
};

export default AccountUpdatedDialog;
